// src/components/SearchInput.js
import React, { useState, useRef, useEffect } from 'react';
import { useWorkflows } from '../contexts/WorkflowContext';
import KeywordChips from './KeywordChips';

const SearchInput = () => {
  const [isFocused, setIsFocused] = useState(false);
  const { searchTerm, setSearchTerm } = useWorkflows();
  const inputRef = useRef(null);
  
  const handleClearSearch = () => {
    setSearchTerm('');
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  // Handle click outside to close keyword chips
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (inputRef.current && !inputRef.current.contains(event.target) && 
          !event.target.closest('#keywordChips')) {
        setIsFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div id="inputWrapper" style={{
      position: 'relative',
      marginBottom: '15px'
    }}>
      <div style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        border: '1px solid #ddd',
        borderRadius: '4px',
        backgroundColor: '#fff'
      }}>
        <input
          id="filterInput"
          ref={inputRef}
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search workflows..."
          onFocus={() => setIsFocused(true)}
          style={{
            width: '100%',
            padding: '8px 32px 8px 10px',
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            fontSize: '14px'
          }}
        />
        {searchTerm && (
          <div 
            id="clearSearchButton"
            onClick={handleClearSearch}
            style={{
              position: 'absolute',
              right: '8px',
              top: '50%',
              transform: 'translateY(-50%)',
              width: '16px',
              height: '16px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '16px',
              color: '#888'
            }}
          >
            ×
          </div>
        )}
      </div>
      <KeywordChips visible={isFocused} />
    </div>
  );
};

export default SearchInput;